import {ErrorHandler, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ErrorDTO} from '../../../submodule/model/error-dto.model';
import {GlobalErrorHandler} from './global-error-handler.service';
import {bufferTime, filter, groupBy, map, mergeMap, take, withLatestFrom} from 'rxjs/operators';
import {ErrorSerializerService} from './errorSerializer.service';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiErrorService {
  private bufferDuration = 30000;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandler,
    private authService: AuthService) {

    (errorHandler as GlobalErrorHandler)
      .errorToNotify$
      .pipe(
        filter(Boolean),
        withLatestFrom(this.authService.getUser().pipe(map(u => u.email))),
        map(([error, email]) => {
          return ErrorSerializerService.toErrorDTO(error, email);
        }),
        groupBy((err) => err.message + err.url),
          mergeMap((group) => {
            return group.pipe(
              bufferTime(this.bufferDuration),
              filter((v) => !!v.length),
              map((errors: ErrorDTO[]): ErrorDTO => {
                return {
                  ...errors[0],
                  temporalMeasure: {
                    unit: 's',
                    count: errors.length,
                    duration: this.bufferDuration/1000
                  }
                };
              })
            )
          })
      ).subscribe((error) => {
        this.notifyError(error)
          .pipe(take(1)).subscribe();
      })
  }

  public notifyError(error: ErrorDTO): Observable<any> {
    return this.http.post(`${environment.backendUrl}error-notification`,
      { error }
    )
  }
}
